export const moneyUsdFormat = (value: number) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
    });
    return formatter.format(value);
};

export const moneyUsdExtendFormat = (value: number) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2,
    });
    const amount = formatter.format(value).split('.');
    return {
        currency: '$',
        parts: amount,
    };
};